'use strict'

exports.util = require('./util.js')
exports.resolver = require('./resolver.js')



//////////////////
// WEBPACK FOOTER
// ./node_modules/ipld-dag-cbor/src/index.js
// module id = IfE5
// module chunks = 0